import { Spin } from "@dreambigger/design-system";
import React, { useCallback, useState } from "react";
import { memo } from "react";

type Props = {
  onLoad?: Function;
  src: string;
  content: React.ReactNode;
  divStyle?: React.CSSProperties;
  imageStyle?: React.CSSProperties;
};

/**
 * Component to display the invite/thank you note preview to the user.
 */
const NotePreviewCard = ({
  onLoad,
  src,
  content,
  divStyle = {
    height: "40px",
    backgroundColor: "white",
    borderBottom: "1px solid #F2F2F2",
    borderRadius: "8px 8px 0 0",
  },
  imageStyle = {
    display: "block",
    height: "100%",
    width: "100%",
    borderRadius: "0 0 8px 8px",
  },
}: Props) => {
  // Keep track of the image's loading state.
  const [loading, setLoading] = useState(true);

  // Set the loading state to true once the image has been downloaded.
  const handleOnLoad = () => {
    setLoading(false);
    if (onLoad) {
      onLoad();
    }
  };

  return (
    <>
      {/* Display Spinner if image is not loaded yet */}
      <div
        className="tc"
        style={{
          display: loading ? "block" : "none",
        }}
      >
        <Spin></Spin>
      </div>
      <div style={{ ...divStyle, display: loading ? "none" : "block" }}>
        <p className="f-3 pt-2 tc">{content}</p>
      </div>
      <img
        style={{
          ...imageStyle,
          display: loading ? "none" : "block",
        }}
        src={src}
        onLoad={handleOnLoad}
      ></img>
    </>
  );
};

export default memo(NotePreviewCard);
